import styled from '@emotion/styled';
import { Modal } from '@mui/material';

import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';

import Button from '@/components/Buttons/Button';
import Close from '../../../images/Close.svg';
import DangerTriangle from '../../../images/DangerTriangle.svg';
import RegenerateArrow from '../../../images/RegenerateArrow.svg';

const StyledModal = styled(Modal)`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StyledPaper = styled.div`
    background-color: white;
    padding: 0px 0px 16px 32px;
    width: 560px;
    border-radius: 10px;
    outline: none;
`;

const Title = styled.div`
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 24px;
    margin-top: 16px;
`;

const CloseButton = styled(MaskedIcon)`
    margin-top: 7px;
    margin-right: 7px;
    color: #242625;
    &:hover {
        cursor: pointer;
    }
`;

const CancelButton = styled(Button)`
    margin-top: 8px;
    width: 240px;
    border-radius: 8px;
    margin-right: 5px;
    font-size: 15px;
    font-weight: 500;
`;

const RegenerateButton = styled(Button)`
    margin-top: 8px;
    width: 240px;
    backdrop-filter: blur(60px);
    border-radius: 8px;
    display: flex;
    margin-left: 5px;
    font-size: 15px;
`;

const WarningIcon = styled.img`
    width: 20px;
    height: 20px;
    margin-left: 5px;
    margin-right: 10px;
`;

const BodyText = styled.span`
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
`;

const ButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    width: 100%;
`;

const HideableMaskedIcon = styled(MaskedIcon)`
    display: flex;
    margin-right: 15px;
`;

const TitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

const BodyWrapper = styled.div`
    margin-top: 16px;
    padding-right: 32px;
`;

interface Props {
    open: boolean;
    onClose: () => void;
    onRegenerate: () => void;
}

export const RegenerateApiKeyModal: React.FC<Props> = ({ open, onClose, onRegenerate }) => {
    return (
        <StyledModal open={open} onClose={onClose}>
            <StyledPaper data-testid="regenerate-api-key-modal-content">
                <TitleWrapper>
                    <Title>
                        <WarningIcon src={DangerTriangle} alt="plus" />
                        Regenerate your API key?
                    </Title>
                    <CloseButton src={Close} size={'18px'} onClick={onClose} />
                </TitleWrapper>
                <BodyWrapper>
                    <BodyText>Any existing API integration will stop working, and you will not able to recover your current key.</BodyText>
                    <ButtonsContainer>
                        <CancelButton color="secondary" variant="outlined" onClick={onClose}>
                            Cancel
                        </CancelButton>
                        <RegenerateButton color="secondary" onClick={onRegenerate} data-testid="regenerate-api-key-dialog-confirm">
                            <HideableMaskedIcon src={RegenerateArrow} size={'20px'} />
                            Yes, Regenerate Key
                        </RegenerateButton>
                    </ButtonsContainer>
                </BodyWrapper>
            </StyledPaper>
        </StyledModal>
    );
};
